import { CameraSubject } from 'streem-sdk-protobuf';
export function flipCamera(cameraSubject) {
    switch (cameraSubject) {
        case CameraSubject.CAMERA_SUBJECT_WORLD:
            return CameraSubject.CAMERA_SUBJECT_PERSON;
        case CameraSubject.CAMERA_SUBJECT_PERSON:
            return CameraSubject.CAMERA_SUBJECT_WORLD;
        default:
            return CameraSubject.CAMERA_SUBJECT_WORLD;
    }
}
//# sourceMappingURL=flip_camera.js.map